import styled from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'
import { Button } from '@at/design-system-elements'
import { isRedButtonTestActive } from '../../../utils/red-button-test'

export const StyledSaveSearchButton = styled(Button)<{
    $foundMatchingSavedSearch: boolean
}>`
    display: block;
    &.atds-button {
        padding: 0;
        margin-left: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
        margin-top: -2px;
        font-size: 16px;
        @media (max-width: 375px) {
            font-size: 14px;
        }
        :hover {
            background-color: transparent;
        }
        svg {
            margin-top: 1px;
            path {
                fill: ${({ theme }) => theme.color.icon.save};
            }
        }
    }
`

export const StyledYourSavedSearchesButton = styled(Button)`
    margin: 16px auto;
    line-height: 18px;
    display: inline-block;
    width: 100%;
    background-color: ${({ theme }) =>
        isRedButtonTestActive ? theme.color.bgFill.highlight : theme.color.bgFill.soft};
    text-align: center;
    &.atds-button {
        line-height: 18px;
        border-radius: 0;
    }
    padding: ${({ theme }) =>
        `${ThemeSelectors.getGroupThreeSpacing(theme)} ${ThemeSelectors.getGroupTwoSpacing(theme)}`};
`
